const FEATURE_HELP_URLS = {
  agent_bots: 'https://center.hiibee.com.br/hc/agent-bots',
  agents: 'https://center.hiibee.com.br/hc/agents',
  audit_logs: 'https://center.hiibee.com.br/hc/audit-logs',
  campaigns: 'https://center.hiibee.com.br/hc/campaigns',
  canned_responses: 'https://center.hiibee.com.br/hc/canned',
  channel_email: 'https://center.hiibee.com.br/hc/email',
  channel_facebook: 'https://center.hiibee.com.br/hc/fb',
  custom_attributes: 'https://center.hiibee.com.br/hc/custom-attributes',
  dashboard_apps: 'https://center.hiibee.com.br/hc/dashboard-apps',
  help_center: 'https://center.hiibee.com.br/hc/help-center',
  inboxes: 'https://center.hiibee.com.br/hc/inboxes',
  integrations: 'https://center.hiibee.com.br/hc/integrations',
  labels: 'https://center.hiibee.com.br/hc/labels',
  macros: 'https://center.hiibee.com.br/hc/macros',
  message_reply_to: 'https://center.hiibee.com.br/hc/reply-to',
  reports: 'https://center.hiibee.com.br/hc/reports',
  sla: 'https://center.hiibee.com.br/hc/sla',
  team_management: 'https://center.hiibee.com.br/hc/teams',
  webhook: 'https://center.hiibee.com.br/hc/webhooks',
  billing: 'https://center.hiibee.com.br/pricing',
  saml: 'https://center.hiibee.com.br/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
